import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import request from '@/utils/request';
import API from '@/config/api';
import type { AccessLog } from '@/types/log.types';
import {
  fetchAccessLogsRequest, fetchAccessLogsSuccess, fetchAccessLogsFailure,
  fetchAccessLogDetailsRequest, fetchAccessLogDetailsSuccess, fetchAccessLogDetailsFailure,
} from './accessLogsSlice';

function* handleFetchAccessLogs(action: PayloadAction<{ page: number; limit: number; search?: string; companyId?: string; dateFrom?: string; dateTo?: string; sortField?: string; sortOrder?: number }>) {
  try {
    const res: { data: { data: { list: AccessLog[]; totalRecords: number } } } = yield call(request.get, API.ACCESS_LOGS, { params: action.payload });
    yield put(fetchAccessLogsSuccess({ list: res.data.data.list, totalCount: res.data.data.totalRecords }));
  } catch (e: unknown) {
    yield put(fetchAccessLogsFailure(e instanceof Error ? e.message : 'Failed'));
  }
}

function* handleFetchAccessLogDetails(action: PayloadAction<{ companyId: string; page: number; limit: number }>) {
  try {
    console.log('Fetching access log details with payload:', action.payload);
    
    const res: { data: { data?: Record<string, unknown>; success?: boolean; message?: string } } = yield call(
      request.post,
      API.ACCESS_LOG_DETAILS,
      action.payload,
    );
    
    console.log('Access log details response:', res);
    
    // Handle different response structures
    if (res && res.data) {
      const details = res.data.data || res.data || {};
      console.log('Extracted details:', details);
      yield put(fetchAccessLogDetailsSuccess(details));
    } else {
      console.error('Invalid response structure:', res);
      yield put(fetchAccessLogDetailsFailure());
    }
  } catch (e: unknown) {
    console.error('Access log details error:', e);
    if (e instanceof Error) {
      console.error('Error message:', e.message);
      console.error('Error stack:', e.stack);
    }
    yield put(fetchAccessLogDetailsFailure());
  }
}

export default function* accessLogsSaga() {
  yield takeLatest(fetchAccessLogsRequest.type, handleFetchAccessLogs);
  yield takeLatest(fetchAccessLogDetailsRequest.type, handleFetchAccessLogDetails);
}
